import apiClient from './apiClient';

/**
 * OJT Monitoring APIs
 */
export const getOJTMonitorings = async (params) => {
  const response = await apiClient.get('/industryConnect/ojt/monitoring', { params });
  return response.data;
};

/**
 * OJT Evaluation APIs
 */
export const getOJTEvaluation = async (studentId, companyId) => {
  // NOTE: Company ID can usually be derived from the logged-in user context in the backend
  // but for the specific route we need it. 
  const response = await apiClient.get(`/industryConnect/ojt/evaluation/${studentId}/${companyId}`);
  return response.data;
};

/**
 * HR INDUSTRY WORKFLOW: Reports & Management
 */

// 2. OJT Trainee Report
export const getOJTTraineeReport = async (params) => {
  const response = await apiClient.get('/industryConnect/hr/reports/ojt-trainees', { params });
  return response.data;
};

// 3. Apprenticeship Trainee Report
export const getApprenticeshipReport = async (params) => {
  const response = await apiClient.get('/industryConnect/hr/reports/apprenticeships', { params });
  return response.data;
};

// 4. Recruitment Report (Engagement analytics)
export const getRecruitmentReport = async (params) => {
  const response = await apiClient.get('/industryConnect/hr/reports/recruitment', { params });
  return response.data;
};

// 5. Placement Report
export const getPlacementReport = async (params) => {
  const response = await apiClient.get('/industryConnect/hr/reports/placements', { params });
  return response.data;
};

// 6. Offer Letter Report
export const getOfferLetterReport = async (params) => {
  const response = await apiClient.get('/industryConnect/hr/reports/offer-letters', { params });
  return response.data;
};

/**
 * HR Opportunity Actions
 */
export const postOpportunity = async (data) => {
  const response = await apiClient.post('/industryConnect/opportunities', data);
  return response.data;
};

export const getEligibleStudents = async (opportunityId) => {
  const response = await apiClient.get(`/industryConnect/opportunities/${opportunityId}/eligible-students`);
  return response.data;
};

export const generateOfferLetter = async (applicationId, data) => {
  const response = await apiClient.post(`/industryConnect/applications/${applicationId}/offer-letter`, data);
  return response.data;
};
export const issueDeploymentOrder = async (applicationId, data) => {
  const response = await apiClient.post(`/industryConnect/applications/${applicationId}/deploy`, data);
  return response.data;
};
